export default () => {
  const settingsGlobals = {};

  const globals = Object.entries(window.$App.globals.settings)
  globals.forEach((global) => (settingsGlobals[`$${global[0].toUpperCase()}`] = global[1]));

  return settingsGlobals
}